//sets the navigation to be sticky
define('sticky-header',[
  "application"
], function(app) {

  var sticky = [];

  window.addEventListener("scroll", function() {
    sticky.forEach(function(element) {
      element.className = element.className.replace(/\s*fixed\s*/g, "");
      var bounds = element.getBoundingClientRect();
      if (bounds.top <= 0) {
        element.className += " fixed";
      }
    });
  });

  app.directive("sticky", function() {
    return {
      restrict: "A",
      link: function(_, element) {
        sticky.push(element[0]);
      }
    };
  });

});
